import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=0be4e3ae&scoped=true&"
import script from "./factory.vue?vue&type=script&lang=js&"
export * from "./factory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4e3ae",
  null
  
)

export default component.exports